export { default as Img200 } from './processed/200/Early-Man.jpg';
export { default as Img400 } from './processed/400/Early-Man.jpg';
export { default as Imgthumb } from './processed/thumb/Early-Man.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Early-Man.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Early-Man.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      231,
      151,
      38
    ],
    "_population": 596,
    "_hsl": [
      0.09758203799654576,
      0.8008298755186721,
      0.5274509803921569
    ]
  },
  "LightVibrant": {
    "_rgb": [
      230,
      172,
      131
    ],
    "_population": 1887,
    "_hsl": [
      0.06902356902356906,
      0.6644295302013422,
      0.7078431372549019
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      87,
      39,
      24
    ],
    "_population": 2133,
    "_hsl": [
      0.03968253968253969,
      0.5675675675675675,
      0.21764705882352942
    ]
  },
  "Muted": {
    "_rgb": [
      158,
      140,
      73
    ],
    "_population": 1947,
    "_hsl": [
      0.13137254901960785,
      0.367965367965368,
      0.45294117647058824
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      165,
      146
    ],
    "_population": 1999,
    "_hsl": [
      0.054597701149425325,
      0.36250000000000016,
      0.6862745098039216
    ]
  },
  "DarkMuted": {
    "_rgb": [
      87,
      50,
      47
    ],
    "_population": 302,
    "_hsl": [
      0.012499999999999985,
      0.29850746268656714,
      0.2627450980392157
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Early-Man.js